import {HttpClient} from "../../service/httpClient/HttpClient";

export class FeedBackService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getFeedBackList(fundID, page, size, fullNameFilter, groupNameFilter, nationalCodeFilter) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/critics-and-suggestions`,
                {
                    size: size,
                    page: page,
                    "full-name": fullNameFilter,
                    "group-name": groupNameFilter,
                    "national-code": nationalCodeFilter
                }
            ).then(resolve).catch(reject)
        })
    }

    getFeedBackInfo(fundID, feedbackId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/critics-and-suggestions/${feedbackId}`
            ).then(resolve).catch(reject)
        })
    }

    changeFeedBackStatus(fundID, feedbackId, status){
        return new Promise((resolve, reject)=>{
            this.httpClient.put(
                `funds/${fundID}/critics-and-suggestions/${feedbackId}/status/${status}`,
            ).then(resolve).catch(reject)
        })
    }
}